export { LogoLarge, LogoRegister, LogoImage, LogoSlogan, LogoText } from './smartguy-logo';